import {Grow} from "@mui/material";
import Box from "@mui/material/Box";
import {Bar} from "react-chartjs-2";
import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import {targets, useReferentialContext} from "../../Context";
import GenericBarChart from "./GenericBars";
import GenericRadarChart from "./GenericRadar";


export default function MetricRadar(props: {paramObjectMain: any, paramObjectReference: any, target: targets, metric: string}){
    const api = useReferentialContext().farsightApi.getSummariesApi(props.target);
    const [mainData, setMainData] = useState([] as any[]);
    const [refData, setRefData] = useState([] as any[]);
    const [fullData, setFullData] = useState([] as any[]);

    const [mainDone, setMainDone] = useState(false);
    const [refDone, setRefDone] = useState(false);

    useEffect(() => {
        api.aggregate({
            ...props.paramObjectMain,
            groupby: ['player'],
            aggregates: ['participant_id__avg'],
            ordering: ['participant_id__avg'],
            metrics: [props.metric]
        }).then(r => {
            console.log(r);
            setMainData(r);
            setMainDone(true);
        });

        api.aggregate({
            ...props.paramObjectReference,
            groupby: ['role'],
            aggregates: ['participant_id__avg'],
            ordering: ['participant_id__avg'],
            metrics: [props.metric]
        }).then(r => {
            setRefData(r);
            setRefDone(true);
        });
    }, [props.paramObjectMain.watermark, props.paramObjectReference.watermark, props.target])

    useEffect(() => {
        if(mainDone && refDone){
            const full_data = mainData.map((main, index) => {
                return {...main, ref : refData[index]};
            })
            setFullData(full_data);
            setMainDone(false);
            setRefDone(false);
        }
    }, [mainDone, refDone])

    return (
        <GenericRadarChart data={fullData} mainLabel={'Team'}
                         labels={(value: any) => value.player}
                         getValue={(value: any) => value[props.metric]}
                         vertical={true}
                         comparisonLabel={'Matchup'}
                         getComparisonValue={(value: any) => value.ref[props.metric]}
        />
    );
}